/*
 * Страница подготовки демо.
 *
 * Аккаунт создаётся в фоне: поддомен, база тенанта и организация в CRM. Здесь
 * видно, на каком шаге процесс, а по готовности страница сама открывает демо.
 */

import { billing, requestJson } from "./billing.js";

const DEFAULT_POLL_MS = 2000;
const NETWORK_RETRY_MS = 4000;
const READY_PAUSE_MS = 700;
const STEP_ORDER = ["account", "workspace", "crm", "done"];

function show(root, view) {
    root.querySelectorAll("[data-progress-view]").forEach((node) => {
        node.hidden = node.dataset.progressView !== view;
    });
}

function renderSteps(root, step) {
    const current = Math.max(STEP_ORDER.indexOf(step), 0);

    root.querySelectorAll("[data-step]").forEach((node) => {
        const index = STEP_ORDER.indexOf(node.dataset.step);
        const state = index < current ? "done" : index === current ? "active" : "pending";

        node.dataset.state = state;
        node.querySelector("[data-step-spinner]")?.toggleAttribute("hidden", state !== "active");
        node.querySelector("[data-step-check]")?.toggleAttribute("hidden", state !== "done");
        node.querySelector("[data-step-dot]")?.toggleAttribute("hidden", state !== "pending");
    });

    const bar = root.querySelector("[data-progress-bar]");
    if (bar) {
        // Шаг считается наполовину пройденным, пока он в работе: полоса
        // двигается на каждом шаге, но не обещает завершения раньше времени.
        const ratio = (current + 0.5) / STEP_ORDER.length;
        bar.style.width = `${Math.round(Math.min(ratio, 1) * 100)}%`;
    }
}

function fail(root, message) {
    const holder = root.querySelector("[data-progress-message]");
    if (holder && message) holder.textContent = message;

    show(root, "failed");
}

export function initDemoProgress() {
    const root = document.querySelector("[data-demo-progress]");
    if (!root) return;

    const uuid = root.dataset.uuid;
    if (!uuid) {
        fail(root, null);
        return;
    }

    const maxWaitMs = Number(root.dataset.maxWaitMs) || 210000;
    const startedAt = Date.now();
    let stopped = false;

    renderSteps(root, "account");

    const finish = (loginUrl) => {
        stopped = true;
        renderSteps(root, "done");
        show(root, "ready");

        // Небольшая пауза, чтобы «Готово» не мигало и переход не выглядел
        // как сбой страницы.
        window.setTimeout(() => window.location.assign(loginUrl), READY_PAUSE_MS);
    };

    const poll = async () => {
        if (stopped) return;

        let next = DEFAULT_POLL_MS;

        try {
            const { ok, status, data } = await requestJson(billing.demoRequest(uuid));

            if (!ok) {
                if (status === 404) {
                    stopped = true;
                    fail(root, root.dataset.msgNotFound || null);
                    return;
                }

                // 429 и 5xx — временные: продолжаем опрашивать реже.
                next = NETWORK_RETRY_MS;
            } else {
                if (data.status === "ready" && data.login_url) {
                    finish(data.login_url);
                    return;
                }

                if (data.status === "failed") {
                    stopped = true;
                    fail(root, data.message || null);
                    return;
                }

                renderSteps(root, data.step || "account");
                next = Number(data.poll_interval_ms) || DEFAULT_POLL_MS;
            }
        } catch (error) {
            next = NETWORK_RETRY_MS;
        }

        // Ждать дольше нет смысла: доступы всё равно придут письмом, а
        // аккаунт продолжит создаваться в фоне.
        if (Date.now() - startedAt > maxWaitMs) {
            stopped = true;
            show(root, "slow");
            return;
        }

        window.setTimeout(poll, next);
    };

    poll();
}
